import React from 'react';

export default function DepndentValue(props) {
  const { relation } = props;
  return (
    <div className={`${relation?.cellClass && 'p-0'}`}>
      <div className={`${!relation?.fixed && relation?.cellClass} h-100`}>
        <div style={{ lineHeight: '1.2' }} className="h-100 d-flex justify-content-center align-items-center">
          {relation?.value || ''}
        </div>
      </div>
    </div>
  );
}
